// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__kTAWr","inputWrap":"CustomTip_inputWrap__hyh8K"};